import React from 'react';
import './FooterBanner.css';

function FooterBanner({
  logoSrc = '/images/icons/nav-logo.png',
  logoAlt = 'The Toronto Clinic - a preventative approach to healthcare',
  addressLine1 = '55 Avenue Road, Suite 2000, East Tower',
  addressLine2 = 'Toronto, ON, Canada, M5R 3L2',
  phone = '416-849-5555',
  fax = '416-849-5551',
  logoHref = '/'
}) {
  return (
    <header className="ttc-header-wrapper py-3 border-bottom">
      <div className="container">
        <div className="row align-items-center justify-content-between gy-3">
          {/* Left Brand Logo */}
          <div className="col-auto">
            <div className="ttc-header-logo-link d-inline-block">
              <img 
                src={logoSrc} 
                alt={logoAlt} 
                className="img-fluid ttc-header-logo"
              />
            </div>
          </div>

          {/* Right Contact Details */}
          <div className="col-auto text-sm-end text-start" >
            <div className="ttc-header-contact-info">
              {addressLine1 && (
                <div className="ttc-header-address-line">{addressLine1}</div>
              )}
              {addressLine2 && (
                <div className="ttc-header-address-line">{addressLine2}</div>
              )}
              {phone && (
                <div className="ttc-header-contact-line mt-1">
                  <span className="fw-semibold">Phone: </span>
                  <a href={`tel:${phone.replace(/[^\d+]/g, '')}`} className="ttc-header-link">
                    {phone}
                  </a>
                </div>
              )}
              {fax && (
                <div className="ttc-header-contact-line">
                  <span className="fw-semibold">Fax: </span>
                  <span>{fax}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default FooterBanner;